import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus"
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus"

import { useGetStrings } from "@app/store/service/cmsService"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Image, classNamez, useViewport } from "@tecreation/funnel-components"
import { AnimatePresence, m } from "framer-motion"
import { useState } from "react"
import Skeleton from "react-loading-skeleton"
import "./SelectionEntry.css"

const BORDER_RADIUS = "12px"

export const SelectionEntry = ({ imgSrc, children, count, onAdd, onRemove, onClick, squareImage, isSkeleton, disabled, expanded, plusDisabled, ariaLabel }) => {
	const [showExpanded, setShowExpanded] = useState(false)
	const [announceMinusButtonAvailable, setAnnounceMinusButtonAvailable] = useState(false)

	const { sm } = useViewport()
	const {
		data: { buttonLabelDecreaseQuantity, buttonLabelIncreaseQuantity, buttonLabelReadMore, buttonLabelReadLess, decreaseQuantityAvailableLabel },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<div
			aria-label={ariaLabel}
			role="group"
			className={"mb-2 relative selectionEntry color-bg-default" + classNamez({ boxShadow: imgSrc, clickable: expanded })}
			onClick={() => {
				if (expanded) {
					setShowExpanded(!showExpanded)
				}
			}}
		>
			<div
				className={"flex flex-items-center fill selectionEntry color-fg-primary" + classNamez({ selectionEntryDisabled: disabled, open: showExpanded })}
				onClick={onClick}
			>
				<div>
					{isSkeleton ? (
						<div className="rounded-left-3 selectionImage flex-shrink-0">
							<Skeleton className="h-100" />
						</div>
					) : (
						<>
							{imgSrc && (
								<Image
									src={imgSrc}
									className={"selectionImage flex-shrink-0 " + (squareImage ? "squareImage" : "")}
									asBackground
									style={{ borderTopLeftRadius: BORDER_RADIUS, borderBottomLeftRadius: showExpanded ? 0 : BORDER_RADIUS }}
								/>
							)}
						</>
					)}
				</div>

				<div className="ml-3 flex-grow-1 of-hidden">
					<div className={sm ? "" : "ellipsis"}>
						{isSkeleton ? (
							<div>
								<Skeleton />
								<Skeleton />
							</div>
						) : (
							children
						)}
					</div>
				</div>

				<div className="flex flex-items-center flex-shrink-0 mr-3 ml-3">
					{isSkeleton ? (
						<div className="selectorIcon">
							<Skeleton className="h-100" />
						</div>
					) : (
						<>
							{count > 0 && (
								<button
									className="counter-btn color-fg-primary flex flex-center circle border color-border-primary f4 selectorIcon"
									onClick={e => {
										e.stopPropagation()
										onRemove()
									}}
									aria-label={buttonLabelDecreaseQuantity}
								>
									<FontAwesomeIcon icon={faMinus} />
								</button>
							)}
							<div role="status" className="sr-only">
								{`${announceMinusButtonAvailable ? decreaseQuantityAvailableLabel : ""}`}
							</div>
							<div role="status" className="f4 f-lg-3 mx-3 mx-lg-4 flex flex-center regular">
								{count}
							</div>
							<button
								className={
									"counter-btn color-fg-primary flex flex-center circle border color-border-primary f4 selectorIcon" +
									classNamez({ plusDisabled: plusDisabled })
								}
								onClick={e => {
									e.stopPropagation()
									if (!plusDisabled) {
										setAnnounceMinusButtonAvailable(count === 0)
										onAdd()
									}
								}}
								aria-label={buttonLabelIncreaseQuantity}
							>
								<FontAwesomeIcon icon={faPlus} />
							</button>
						</>
					)}
				</div>
			</div>

			{/* Screen reader support*/}
			<div role="status" className="sr-only">
				{showExpanded && expanded}
			</div>

			<AnimatePresence>
				{showExpanded && (
					<m.div
						className="z-9 of-hidden w-100 selectionEntry__expanded"
						style={{ originY: 0 }}
						initial={{
							height: 0,
						}}
						animate={{
							height: "auto",
							transition: {
								duration: 0.4,
							},
						}}
						exit={{
							height: 0,
							transition: { duration: 0.4 },
						}}
					>
						{expanded}
					</m.div>
				)}
			</AnimatePresence>
			{expanded && (
				<button
					className="expand-btn flex-center px-3 clickable"
					style={{
						position: "absolute",
						left: "50%",
						transform: "translateX(-50%)",
						bottom: "4px",
					}}
					aria-label={showExpanded ? buttonLabelReadLess : buttonLabelReadMore}
					aria-expanded={showExpanded}
				>
					<FontAwesomeIcon icon={faChevronDown} className={classNamez({ "fa-rotate-180 ": showExpanded })} />
				</button>
			)}
		</div>
	)
}
